import React from "react";
import Button from "@material-ui/core/Button";
import { Img } from "react-image";
import { noImage } from "../../../../resources/images";

function RelatedAssets({ picture, heading, subheading }) {
  return (
    <div className='RelatedAssetsWrapper'>
      <ul>
        <li>
          <span className='pressPicture'>
          <Img src={[picture , noImage]}/>
          </span>
        </li>
        <li>
          <h2>{heading}</h2>
          <span className='subheading' style={{ marginTop: "7px" }}>
            {subheading}
          </span>
        </li>
      </ul>

      <Button variant='contained' color='primary'>
        View Assets
      </Button>
    </div>
  );
}

export default RelatedAssets;
